import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// import { DashboardUserInfoRow } from './DashboardUserInfoRow';
import { FinancingSection } from './FinancingSection/FinancingSection';
import { AreaRatesSearch } from './Loans/AreaRatesSearch';
import { Footer } from './Footer/Footer';

import { gtag_report_conversion } from '../utils';

import { useLocalStorage } from '../CustomHooks/useLocalStorage';

import { setUserInfo, handleAuthCallbacks } from '../actions';

import { TOKEN, handleSettingsClick, LOGOUT } from '../constants';
import { NY } from '../constants/Dashboard/Residency';

import './Dashboard.css';

export const Dashboard = ({ setPathname }) => {
  const { user, jwt, residencyReducer } = useSelector(
    ({ userReducer: { user, jwt }, residencyReducer }) => ({
      user,
      jwt,
      residencyReducer,
    }),
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value] = useLocalStorage(TOKEN);

  useEffect(() => {
    const urlToken = new URLSearchParams(window.location.search).get('token');
    if (urlToken && !localStorage.getItem(TOKEN)) {
      try {
        const decoded = JSON.parse(atob(urlToken.split('.')[1]));
        const exp = new Date(decoded.exp * 1000);

        if (exp > new Date()) {
          localStorage.setItem(TOKEN, urlToken);

          if (decoded.first_time_sign_up) {
            const issuedAt = new Date(decoded.iat * 1000);
            const now = new Date();

            const withinLastHour = now.getTime() - issuedAt.getTime() <= 60 * 60 * 1000;

            if (withinLastHour) {
              gtag_report_conversion('/dashboard');
            }
          }

          dispatch(handleAuthCallbacks(urlToken));
          navigate('/dashboard');
        } else {
          handleSettingsClick[LOGOUT]?.(dispatch, decoded);
          return;
        }
      } catch (e) {
        console.error('Invalid token from URL', e);
        navigate('/login');
      }
    }
  }, []);

  useEffect(() => {
    if (value || jwt) {
      if (!localStorage.getItem(TOKEN)) {
        return;
      }
      const user = atob(localStorage.getItem(TOKEN)?.split('.')?.[1]);
      const parsedUser = JSON.parse(user);

      if (parsedUser) {
        const date = new Date(parsedUser.exp * 1000);
        const now = new Date();
        if (date < now) {
          handleSettingsClick[LOGOUT]?.(dispatch, parsedUser);
          return;
        }

        dispatch((dispatch) => setUserInfo(dispatch, parsedUser));
      }
    }
  }, [value, jwt]);

  // Default zip code in rates search is 10001 Manhattan
  // Default to location in upstate NY
  const [zip_code, setZipCode] = useState(residencyReducer['Zip Code'] || '12025');
  const [us_state, setUsState] = useState(residencyReducer['State']);

  const [houseOfWorshipZipCode, setHouseOfWorshipZipCode] = useState('');
  const [houseOfWorshipState, setHouseOfWorshipState] = useState(NY);

  const [employmentZipCode, setEmploymentZipCode] = useState('');
  const [employmentState, setEmploymentState] = useState(NY);

  const [segsList, setSegsList] = useState({ 'Select Savers Club': 'Select Savers Club' });
  const [isQuorumEligible, setIsQuorumEligible] = useState(true);

  if (!value) {
    navigate('/login');
  }

  if (!user) {
    return 'Loading!';
  }

  return (
    <div>
      <div className="dashboard-wrapper">
        {/* <DashboardUserInfoRow
          setZipCode={setZipCode}
          setUsState={setUsState}
          user={user}
          tokenValue={value}
        /> */}
        <div className="area-rates-search-wrapper">
          <AreaRatesSearch
            zipCode={zip_code}
            onZipCodeChange={(value) => {
              if (value.length <= 5) {
                setZipCode(value);
              }
            }}
            usState={us_state}
            onUsStateChange={setUsState}
            houseOfWorshipZipCode={houseOfWorshipZipCode}
            onHouseOfWorshipZipCodeChange={(value) => {
              if (value.length <= 5) {
                setHouseOfWorshipZipCode(value);
              }
            }}
            houseOfWorshipUsState={houseOfWorshipState}
            onHouseOfWorshipUsStateChange={(value) => {
              if (value.length <= 5) {
                setHouseOfWorshipState(value);
              }
            }}
            employmentZipCode={employmentZipCode}
            onEmploymenZipCodeChange={(value) => {
              if (value.length <= 5) {
                setEmploymentZipCode(value);
              }
            }}
            employmentUsState={employmentState}
            onEmploymentStateChange={(value) => {
              if (value.length <= 5) {
                setEmploymentState(value);
              }
            }}
            filter="dashboard"
            segsList={segsList}
            setSegsList={setSegsList}
            isQuorumEligible={isQuorumEligible}
            setIsQuorumEligible={setIsQuorumEligible}
          />
        </div>
        <FinancingSection
          zip_code={zip_code}
          us_state={us_state}
          houseOfWorshipZipCode={houseOfWorshipZipCode}
          houseOfWorshipState={houseOfWorshipState}
          employmentUsState={employmentState}
          employmentZipCode={employmentZipCode}
          user={user}
          setPathname={setPathname}
          segsList={segsList}
          isQuorumEligible={isQuorumEligible}
        />
      </div>
      <div className="mobile-view-only">
        <Footer currentPath={'/dashboard'} />
      </div>
    </div>
  );
};
